import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=3572b013&scoped=true"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"
import style0 from "./Store.vue?vue&type=style&index=0&id=3572b013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572b013",
  null
  
)

export default component.exports